import { render, staticRenderFns } from "./FuelTypeBadge.vue?vue&type=template&id=4fa598cc&"
import script from "./FuelTypeBadge.vue?vue&type=script&lang=js&"
export * from "./FuelTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports